import React from 'react';
import { Card, CardContent } from './ui/Card';
import { BoxIcon } from 'lucide-react';
interface FeatureCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
}
export function FeatureCard({
  title,
  description,
  icon: Icon
}: FeatureCardProps) {
  return <Card hover className="h-full border-0 shadow-lg ring-1 ring-gray-900/5" data-id="element-39">
      <CardContent className="p-8" data-id="element-40">
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 mb-6" data-id="element-41">
          <Icon className="h-6 w-6 text-primary" data-id="element-42" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-43">{title}</h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-44">{description}</p>
      </CardContent>
    </Card>;
}